module.exports = __webpack_public_path__ + "d8c73b9716db2a392d03451ab6f17c11.png";